<div class="splitcontent">
    <div class="leftbar">
        <app-icon-block-settings></app-icon-block-settings>
    </div>
    <div class="rightblock">
        <!-- <app-favourite-pages [pageDetails]="pageDetails"></app-favourite-pages> -->
        <div class="content-side">
            <div class="row">
                <div class="col-2-of-2">
                    <app-column-header [headerData]="headerData"></app-column-header>
                    <!-- <h2>FAQ</h2> -->
                    <div class="faqs" *ngFor="let data of faqData">
                        <h4>{{data.qstn}}</h4>
                        <a class="viewdocs" (click)="openModal(data.tbl_gstibo_faq_details_id)"
                            [style.pointer-events]="data.re_count?'auto':'none'" title="Click To View">{{data.gstibo_menu && siteValue? data.gstibo_menu + ' Tutorial': 'View Docs' }}</a>
                        <p>{{data.gstibo_faq_answer}}</p>
                    </div>
                </div>
            </div>
        </div>
        <footer *ngIf="isNotLoading" class="center-footer pos-unset">
            <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
        </footer>
    </div>
</div>